import {IssueRelationships} from '@github-ui/server-persisted-queries'
import type {IssueRelationshipsQuery} from '@github-ui/server-persisted-queries/types/IssueRelationships'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type SecurityAlertsConnection = NonNullable<
  NonNullable<NonNullable<IssueRelationshipsQuery['repository']>['issue']>['securityAlerts']
>

export type SecurityAlertNode = NonNullable<NonNullable<SecurityAlertsConnection['nodes']>[number]>

export function securityAlertsQueryKey(owner: string, repo: string, number: number) {
  return ['issue-viewer', 'security-alerts', {owner, repo, number}] as const
}

export async function fetchSecurityAlerts(
  owner: string,
  repo: string,
  number: number,
  signal?: AbortSignal,
): Promise<SecurityAlertNode[]> {
  const response = await verifiedFetchJSON(
    `/${owner}/${repo}/issues/${number}/relationships?queryId=${IssueRelationships}`,
    {signal},
  )
  if (!response.ok) {
    throw new Error(`Security alerts fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {data?: IssueRelationshipsQuery; errors?: unknown[]}
  if (!json.data) {
    throw new Error('Security alerts query returned no data')
  }

  return (json.data.repository?.issue?.securityAlerts?.nodes || []).flatMap(node => (node ? node : []))
}
